<div class="card">
  <!-- Header with filters -->
  <div class="card-header border-bottom">
    <div class="d-flex flex-column flex-lg-row gap-3">
      <!-- Search -->
      <div class="flex-grow-1">
        <div class="input-group">
          <span class="input-group-text bg-light border-end-0">
            <i class="fa-solid fa-search text-muted"></i>
          </span>
          <input type="text" class="form-control border-start-0 ps-0"
                 [(ngModel)]="searchQuery"
                 (keyup.enter)="onSearch()"
                 [placeholder]="'admin.companies.searchPlaceholder' | translate">
          <app-button variant="primary" (clicked)="onSearch()" label="{{ 'common.search' | translate }}"></app-button>
        </div>
      </div>

      <!-- Filters -->
      <div class="d-flex gap-3 align-items-center">
        <select class="form-select form-select-sm" style="width: auto;" [(ngModel)]="companyType" (change)="onFilterChange()">
          @for (type of companyTypes; track type.value) {
            <option [value]="type.value">{{ type.label }}</option>
          }
        </select>
        <div class="form-check mb-0">
          <input type="checkbox" class="form-check-input" id="activeOnly"
                 [(ngModel)]="activeOnly" (change)="onFilterChange()">
          <label class="form-check-label text-nowrap" for="activeOnly">{{ 'admin.companies.activeOnly' | translate }}</label>
        </div>
        <div class="text-muted text-nowrap ms-2">
          <strong>{{ totalItems }}</strong> {{ 'admin.companies.totalCount' | translate | lowercase }}
        </div>
      </div>
    </div>
  </div>

  <!-- Content -->
  <div class="card-body p-0">
    @if (loading) {
      <div class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    } @else if (companies.length === 0) {
      <div class="text-center py-5 text-muted">
        <i class="fa-solid fa-building fa-3x mb-3 opacity-50"></i>
        <p class="mb-0">{{ 'admin.companies.noResults' | translate }}</p>
      </div>
    } @else {
      <!-- Table header -->
      <div class="table-header">
        <div class="th-name">{{ 'admin.companies.name' | translate }}</div>
        <div class="th-type">{{ 'admin.companies.type' | translate }}</div>
        <div class="th-location">{{ 'admin.companies.location' | translate }}</div>
        <div class="th-email">{{ 'admin.companies.email' | translate }}</div>
        <div class="th-created">{{ 'admin.companies.created' | translate }}</div>
      </div>

      <!-- Company list -->
      <div class="company-list">
        @for (company of companies; track company.company_id) {
          <div class="company-item">
            <!-- Name -->
            <div class="company-item-main">
              <div class="company-logo">
                @if (company.company_logo_url) {
                  <img [src]="company.company_logo_url" alt="" class="logo-img">
                } @else {
                  <div class="logo-placeholder">
                    <i class="fa-solid fa-building"></i>
                  </div>
                }
              </div>
              <div class="company-info">
                <div class="company-name">
                  {{ company.company_name }}
                  @if (company.active) {
                    <span class="badge bg-success-subtle text-success">{{ 'common.active' | translate }}</span>
                  } @else {
                    <span class="badge bg-danger-subtle text-danger">{{ 'common.inactive' | translate }}</span>
                  }
                </div>
                <div class="company-id">{{ company.company_id }}</div>
              </div>
            </div>

            <!-- Type -->
            <div class="company-type">
              <span class="type-badge">{{ getCompanyTypeLabel(company.company_type) }}</span>
            </div>

            <!-- Location -->
            <div class="company-location">
              @if (company.city || company.country) {
                {{ company.city }}{{ company.city && company.country ? ', ' : '' }}{{ company.country }}
              } @else {
                <span class="text-muted">-</span>
              }
            </div>

            <!-- Email -->
            <div class="company-email">
              @if (company.email) {
                <a [href]="'mailto:' + company.email">{{ company.email }}</a>
              } @else {
                <span class="text-muted">-</span>
              }
            </div>

            <!-- Created -->
            <div class="company-created">
              {{ company.created_at | date:'dd.MM.yyyy' }}
            </div>
          </div>
        }
      </div>

      <!-- Pagination -->
      @if (totalPages > 1) {
        <div class="card-footer bg-light d-flex justify-content-between align-items-center">
          <span class="text-muted small">
            {{ 'admin.pagination.showing' | translate }} {{ (currentPage - 1) * perPage + 1 }}-{{ Math.min(currentPage * perPage, totalItems) }} {{ 'admin.pagination.of' | translate }} {{ totalItems }}
          </span>
          <nav>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="currentPage === 1">
                <a class="page-link" (click)="currentPage > 1 && onPageChange(currentPage - 1)">
                  <i class="fa-solid fa-chevron-left"></i>
                </a>
              </li>
              @for (page of getPages(); track page) {
                <li class="page-item" [class.active]="page === currentPage">
                  <a class="page-link" (click)="onPageChange(page)">{{ page }}</a>
                </li>
              }
              <li class="page-item" [class.disabled]="currentPage === totalPages">
                <a class="page-link" (click)="currentPage < totalPages && onPageChange(currentPage + 1)">
                  <i class="fa-solid fa-chevron-right"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      }
    }
  </div>
</div>
